var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"attivita-riepilogo-cp-container",class:_vm.classRiepilogoCp},[(_vm.riepilogo)?[_c('msp-tabella-records',{attrs:{"data":_vm.riepilogo},on:{"select-row":_vm.selectRow}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }